// Judgeme - Improve thumbnail image resolution and change to flex layout
const widgetBody = $('.jdgm-rev-widg__body');

const initFlexLayout = () => {
  $('.jdgm-rev').each((i, obj) => {
    const header = $(obj).find('.jdgm-rev__header');
    const content = $(obj).find('.jdgm-rev__content');
    const title = $(obj).find('.jdgm-rev__title');
    const body = $(obj).find('.jdgm-rev__body');
    const form = $(obj).find('.jdgm-rev__custom-form');
    const pics = $(obj).find('.jdgm-rev__pics');
    $(title).before(header);
    $(content).after(pics);
  })
};

const initJudgeMeImageHQ = () => {
  $('.jdgm-rev__pic-img').each((i, obj) => {
    const imageHqSrc = $(obj).parent('.jdgm-rev__pic-link').attr('href');
    $(obj).attr('data-src', imageHqSrc);
  });
  $(widgetBody).addClass('loaded');
};

const checkIfReviewsLoaded = () => {
  const styleAttr = $(widgetBody).attr('style');
  
  $(widgetBody).removeClass('loaded');

  if (styleAttr == '') { // Widget has loaded
    $(widgetBody).addClass('loaded');
    initFlexLayout();
    initJudgeMeImageHQ();
  }
  else { // Widget not loaded, try again
    window.setTimeout(checkIfReviewsLoaded, 200);
  }
};

$(document).on('click', $('.jdgm-paginate__page'), (event) => {
  if ($(event.target).hasClass('jdgm-paginate__page')) {
    checkIfReviewsLoaded();
  }
});

$(document).ready(() => {
  initFlexLayout();
  initJudgeMeImageHQ();
});